import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InstagramLabel,
  InstagramLabelVariables
} from "./types/InstagramLabel";
import {
  InstagramLabelList,
  InstagramLabelListVariables
} from "./types/InstagramLabelList";

const instagramLabelList = gql`
  ${pageInfoFragment}
  query InstagramLabelList(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: InstagramLabelSortingInput
  ) {
    instagramLabels(
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          id
          name
          instagramList {
            id
          }
          instagramSortList {
            id
          }
          instagramUnsortList {
            id
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useInstagramLabelList = makeQuery<
  InstagramLabelList,
  InstagramLabelListVariables
>(instagramLabelList);

export const labelInsFrament = gql`
  fragment LabelInsFrament on InstagramLabel {
    id
    sortOrder
    imgUrl
    userName
    insId
    published
    visible
    instagram {
      imageThumb
      id
    }
  }
`;

export const instagramLabel = gql`
  ${labelInsFrament}
  query InstagramLabel($id: ID!) {
    instagramLabel(id: $id) {
      id
      name
      instagramList {
        ...LabelInsFrament
      }
      instagramSortList {
        ...LabelInsFrament
      }
      instagramUnsortList {
        ...LabelInsFrament
      }
    }
  }
`;
export const useInstagramLabel = makeQuery<
  InstagramLabel,
  InstagramLabelVariables
>(instagramLabel);
